import { UpdateUserInfoPutRequestModel } from "@/features/user/services/update-user-info-model";
import { UpdateUserInfoApi } from "@/features/user/services/update-user-info-api";

// 利用者情報更新処理
export class UpdateUserInfoService {
  private updateUserInfoApi = new UpdateUserInfoApi();
  /**
   * 利用者情報更新API実行
   */
  public async updateUserInfo(param: UpdateUserInfoPutRequestModel) {
    return await this.updateUserInfoApi.putUpdateUserInfo(param);
  }
}
